import { FunnelStepInterface } from 'shared/types/payment-interface'
import httpClient from 'shared/utils/http-client'

export const SALES_FUNNELS_API = '/api/dashboard/customer/membership/courses/filter/sales-funnel'
export const SALES_FUNNEL_STEP_API =
  '/api/dashboard/customer/membership/courses/filter/sales-funnel-step'

export const getFunnelSteps = (id: number) =>
  httpClient.get<FunnelStepInterface[]>(`${SALES_FUNNEL_STEP_API}/${id}`)
